export function AccessDeniedPage() {
  return (
    <div className="center-screen">
      <div className="card login-card">
        <h1>Access not granted</h1>
        <p className="muted">
          Your account isn&apos;t set up in Tricord Quotes yet. Ask an administrator to add you, then sign in again.
        </p>
        <a className="btn" href="/auth/logout" style={{ marginTop: '1rem', display: 'inline-block' }}>
          Sign out
        </a>
      </div>
    </div>
  );
}
